import { useMemo } from 'react';
import styled from 'styled-components';
import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { colors } from 'ui/theme/colors';
import { AlertsModalType, useAlertsModalContext } from '../../context';

export const DestructiveText = styled.span`
  color: ${colors.textDestructive};
`;

export const useAlertDestinationMenuOptions = (webhookId: number): ActionMenuOption[] => {
  const { openModal } = useAlertsModalContext();

  return useMemo(
    () => [
      {
        as: AllowedActionMenuElements.Button,
        content: 'Edit',
        id: 'action-menu-edit-webhook',
        onClick: () => openModal(AlertsModalType.EditWebhookModal, { webhookId }),
      },
      {
        as: AllowedActionMenuElements.Button,
        content: <DestructiveText>Delete webhook</DestructiveText>,
        id: 'action-menu-delete-webhook',
        onClick: () => openModal(AlertsModalType.DeleteWebhookModal, { webhookId }),
      },
    ],
    [webhookId],
  );
};
